import React from 'react';
import { Redirect } from 'react-router-dom';
import ReactTable from 'react-table';
import { RowButton } from '../RowButton';
import QuickLinksService from '../../services/quick_links_service';

class QuickLinkList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
            linkTo: null
        };
    }

    componentDidMount() {
        QuickLinksService.getAll().then(response => {
            const sorted = [...response.quickLinks].sort((a, b) => a.displayOrder - b.displayOrder);
            this.setState({ data: sorted, loading: false });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
            this.props.localErrorHandler(error.message);
        });
    }

    editLinkClick(rowId) {
        this.setState({ linkTo: `/admin-admin/quick-links/edit/${rowId}` });
    }

    moveItem(itemId, direction) {
        const { data } = this.state;
        const index = data.findIndex(item => item.id === itemId);
        const swapIndex = index + direction;
        if (swapIndex < 0 || swapIndex >= data.length) return;

        const reordered = [...data];
        [reordered[index], reordered[swapIndex]] = [reordered[swapIndex], reordered[index]];
        const normalized = reordered.map((item, i) => ({ ...item, displayOrder: i }));

        const changedA = normalized[index];
        const changedB = normalized[swapIndex];

        Promise.all([
            QuickLinksService.save(changedA, changedA.id),
            QuickLinksService.save(changedB, changedB.id)
        ]).then(() => {
            this.setState({ data: normalized });
        }).catch(error => {
            console.error(error);
            this.props.localErrorHandler(error.message);
        });
    }

    render() {
        if (this.state.linkTo) {
            return <Redirect push to={this.state.linkTo} />;
        }

        const { data, loading } = this.state;

        return (
            <div className="react-table-custom">
                <ReactTable
                    className="-striped -highlight"
                    data={data}
                    loading={loading}
                    showPaginationTop
                    columns={[
                        {
                            id: 'order',
                            sortable: false,
                            width: 90,
                            Cell: cell => {
                                const index = data.findIndex(item => item.id === cell.original.id);
                                return (
                                    <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                                        <button
                                            className="btn btn-xs btn-default"
                                            disabled={index === 0}
                                            onClick={() => this.moveItem(cell.original.id, -1)}
                                        >▲</button>
                                        <button
                                            className="btn btn-xs btn-default"
                                            disabled={index === data.length - 1}
                                            onClick={() => this.moveItem(cell.original.id, 1)}
                                        >▼</button>
                                    </div>
                                );
                            }
                        },
                        {
                            Header: 'Title',
                            id: 'title',
                            accessor: 'title',
                            sortable: false,
                            minResizeWidth: 50
                        },
                        {
                            Header: 'URL',
                            id: 'url',
                            accessor: 'url',
                            sortable: false,
                            minResizeWidth: 50,
                            Cell: cell => (
                                <a href={cell.value} target="_blank" rel="noopener noreferrer">{cell.value}</a>
                            )
                        },
                        {
                            Cell: cell => (
                                <RowButton
                                    allowEdit={true}
                                    editClick={this.editLinkClick.bind(this)}
                                    rowId={cell.original.id}
                                />
                            ),
                            sortable: false,
                            minResizeWidth: 50,
                            width: 230
                        }
                    ]}
                />
            </div>
        );
    }
}

export default QuickLinkList;
